import { Fragments } from "requests";
import { OCCLUSION_DESCRIPTION_VALUES } from "./constants";

export const getDefaultValues = (
  generalAssessment: Fragments.StoredGeneralAssessment
) => ({
  dentalChart: generalAssessment?.dentalChart || null,
  skullType: generalAssessment?.skullType || null,
  extraoral: generalAssessment?.extraoral || null,
  lymphNodes: generalAssessment?.lymphNodes || null,
  tonsils: generalAssessment?.tonsils || null,
  softPalate: generalAssessment?.softPalate || null,
  hardPalate: generalAssessment?.hardPalate || null,
  buccalMucosa: generalAssessment?.buccalMucosa || null,
  caudalOralMucosa: generalAssessment?.caudalOralMucosa || null,
  tongue: generalAssessment?.tongue || null,
  fistula:
    generalAssessment?.fistula != null ? generalAssessment.fistula : null,
  parulisSinusTract:
    generalAssessment?.parulisSinusTract != null
      ? generalAssessment.parulisSinusTract
      : null,
  occlusion: generalAssessment?.occlusion || null,
  occlusionDescription:
    generalAssessment?.occlusionDescription ||
    (generalAssessment?.occlusion
      ? OCCLUSION_DESCRIPTION_VALUES[generalAssessment.occlusion]
      : ""),
  periodontalDisease: generalAssessment?.periodontalDisease || null,
  plaqueIndex: generalAssessment?.plaqueIndex || null,
  calculusIndex: generalAssessment?.calculusIndex || null,
  gingivalIndex: generalAssessment?.gingivalIndex || null,
  additionalCommentsAndNotes:
    generalAssessment?.additionalCommentsAndNotes || ""
});
